// commonAPI.js - 公共 API 封装

import { factorArrCheckout } from '@/api/index';

export const factorArrCheckoutFun = (factors) => {
  return factorArrCheckout({
    factors: factors
  })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return false;
    });
};
